import React from 'react'
import { MdSubdirectoryArrowRight } from 'react-icons/md';
import { RiInstagramFill, } from 'react-icons/ri';
import { BsFacebook, BsLinkedin, BsTwitter, BsYoutube } from 'react-icons/bs';
import ScrollToTop from 'react-scroll-to-top';
import UperFooter from './UperFooter';
import { useNavigate } from 'react-router-dom';



const Footer = ({ loader }) => {

    const navigate = useNavigate()
    const chengRouts = (routs) => {
        loader(true)
        setTimeout(() => {
            navigate(routs)
        }, 500)
    }
    return (
        <div style={{ background: '#f8fafc', marginTop: '-2px', borderTop: '1px solid #e2e8f0' }}>
            <ScrollToTop top="20" width='20' />

            {/* Top accent line */}
            <div style={{ height: '3px', background: 'linear-gradient(90deg, #1e3a8a 0%, #dc2626 50%, #1e3a8a 100%)' }} />

            <div style={{ padding: '48px 0 0' }}>
                <div className='col-11 m-auto row gap-md-0 gap-4'>

                    {/* Connect column */}
                    <div className='col-md-5 text-start'>
                        {/* Badge */}
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'linear-gradient(135deg, rgba(30,58,138,0.08), rgba(220,38,38,0.06))', border: '1px solid rgba(30,58,138,0.15)', borderRadius: '30px', padding: '6px 16px', marginBottom: '20px' }}>
                            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#1e3a8a', display: 'inline-block', animation: 'pulse 2s infinite' }}></span>
                            <span style={{ color: '#1e3a8a', fontSize: '12px', fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase' }}>Get In Touch</span>
                        </div>

                        {/* Heading */}
                        <div style={{ marginBottom: '12px' }}>
                            <p className='fw-bold mb-0' style={{ color: '#1e3a8a', fontSize: '42px', lineHeight: 1.1 }}>Connect</p>
                            <p className='fw-bold' style={{ color: '#0f172a', fontSize: '42px', lineHeight: 1.1 }}>With Us</p>
                        </div>

                        {/* Divider */}
                        <div style={{ width: '50px', height: '3px', background: 'linear-gradient(90deg, #1e3a8a, #dc2626)', borderRadius: '2px', marginBottom: '20px' }}></div>

                        {/* Tagline */}
                        <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.7', marginBottom: '24px', maxWidth: '280px' }}>
                            Have questions or want to learn more about Arthro 3D? Reach out and we'll get back to you.
                        </p>

                        {/* Email CTA */}
                        <a
                            href='mailto:support@arthro3d.com'
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'linear-gradient(135deg, #1e3a8a, #1e40af)', color: '#fff', textDecoration: 'none', fontWeight: 600, fontSize: '14px', padding: '12px 22px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(30,58,138,0.25)', transition: 'all 0.25s' }}
                            onMouseEnter={e => { e.currentTarget.style.background = 'linear-gradient(135deg, #dc2626, #b91c1c)'; e.currentTarget.style.boxShadow = '0 4px 15px rgba(220,38,38,0.3)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                            onMouseLeave={e => { e.currentTarget.style.background = 'linear-gradient(135deg, #1e3a8a, #1e40af)'; e.currentTarget.style.boxShadow = '0 4px 15px rgba(30,58,138,0.25)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                            support@arthro3d.com
                        </a>
                    </div>


                    {/* Menu & Office columns */}
                    <div className='col-md-7 row gap-sm-0 gap-4'>

                        {/* Menu */}
                        <div className='col-sm-6 text-start'>
                            <p className='fw-bold text-dark mb-3' style={{ fontSize: '15px', letterSpacing: '0.5px', borderBottom: '2px solid #1e3a8a', paddingBottom: '8px', display: 'inline-block' }}>Menu</p>
                            {[
                                { label: 'About ARTHRO3D', path: '/' },
                                { label: 'AI & 3D Robotics', path: '/ai-3d-robotics' },
                                { label: 'Our Packages', path: '/our-packages' },
                                { label: 'Media', path: '/media' },
                                { label: 'Contact us', path: '/contact' },
                            ].map((item, i) => (
                                <p
                                    key={i}
                                    className='mt-2 mb-0'
                                    style={{ color: '#66707A', cursor: 'pointer', fontSize: '14px', transition: 'all 0.2s', paddingLeft: '0px' }}
                                    onClick={() => chengRouts(item.path)}
                                    onMouseEnter={e => { e.currentTarget.style.color = '#1e3a8a'; e.currentTarget.style.paddingLeft = '6px'; }}
                                    onMouseLeave={e => { e.currentTarget.style.color = '#66707A'; e.currentTarget.style.paddingLeft = '0px'; }}
                                >{item.label}</p>
                            ))}
                        </div>

                        {/* Office */}
                        <div className='col-sm-6 text-start'>
                            <p className='fw-bold text-dark mb-3' style={{ fontSize: '15px', letterSpacing: '0.5px', borderBottom: '2px solid #dc2626', paddingBottom: '8px', display: 'inline-block' }}>Office</p>
                            <p className='mt-2' style={{ color: '#66707A', fontSize: '14px', lineHeight: '1.7' }}>
                                19 Shantinagar Society, <br /> Ashram Rd, Nava Vadaj, <br /> Ahmedabad
                            </p>
                            <p className='mt-2' style={{ color: '#66707A', fontSize: '14px' }}>
                                Phone : <a href="tel:+9173914080" style={{ color: '#1e3a8a', textDecoration: 'none', fontWeight: 600 }}>+91 9173914080</a>
                            </p>
                            <div className='d-flex gap-3 mt-3'>
                                {[
                                    { href: 'https://www.linkedin.com/in/arthro3d-llp-739a372a4/', icon: <BsLinkedin />, color: '#0a66c2' },
                                    { href: 'https://www.facebook.com/profile.php?id=100063868277093', icon: <BsFacebook />, color: '#1877f2' },
                                    { href: 'https://www.youtube.com/@arthro3d594', icon: <BsYoutube />, color: '#ff0000' },
                                ].map((s, i) => (
                                    <a
                                        key={i}
                                        href={s.href}
                                        target='_blank'
                                        rel='noreferrer'
                                        style={{ width: '38px', height: '38px', borderRadius: '10px', background: '#e2e8f0', border: '1px solid #cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#475569', fontSize: '18px', transition: 'all 0.25s', textDecoration: 'none' }}
                                        onMouseEnter={e => { e.currentTarget.style.background = s.color; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = s.color; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#475569'; e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.transform = 'translateY(0)'; }}
                                    >{s.icon}</a>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Bottom bar */}
            <div style={{ marginTop: '40px', borderTop: '1px solid #e2e8f0', background: '#f1f5f9' }}>
                <div className='col-11 m-auto d-flex align-items-center justify-content-between py-3 flex-wrap gap-3'>

                    {/* Copyright + Developed by */}
                    <p style={{ color: '#94a3b8', fontSize: '13px', margin: 0 }}>
                        © {new Date().getFullYear()} <span style={{ color: '#0f172a', fontWeight: 600 }}>Arthro 3D LLP</span> All rights reserved. &nbsp;·&nbsp; Developed by :&nbsp;
                        <a
                            href="https://invisiblefiction.com/"
                            target="_blank"
                            rel="noreferrer"
                            style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '5px', fontWeight: 700, verticalAlign: 'middle' }}
                        >
                            <img
                                src="https://s2.googleusercontent.com/s2/favicons?domain=invisiblefiction.com&sz=64"
                                alt="Invisible Fiction Logo"
                                style={{ height: '18px', borderRadius: '3px', verticalAlign: 'middle' }}
                            />
                            <span>
                              <span style={{ color: '#0f172a' }}>Invisible </span>
                              <span style={{ color: '#dc2626' }}>Fiction</span>
                            </span>
                        </a>
                    </p>

                    {/* Legal links */}
                    <div className='d-flex gap-4'>
                        <p
                            style={{ color: '#94a3b8', fontSize: '13px', margin: 0, cursor: 'pointer', transition: 'color 0.2s' }}
                            onMouseEnter={e => e.currentTarget.style.color = '#1e3a8a'}
                            onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
                        >Terms &amp; Conditions</p>
                        <p
                            style={{ color: '#94a3b8', fontSize: '13px', margin: 0, cursor: 'pointer', transition: 'color 0.2s' }}
                            onMouseEnter={e => e.currentTarget.style.color = '#1e3a8a'}
                            onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
                        >Privacy Policy</p>
                    </div>

                </div>
            </div>

        </div>
    )
}


export default Footer
